export enum OrdersDeliveryMethods {
  nextDay = "nextDay",
  nominated = "nominated",
  standard = "standard",
}
